import React, { useState } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserFriends, faNewspaper, faList, faChartLine, faHome } from '@fortawesome/free-solid-svg-icons';
import './NavMenu.css';
import { UserPearl } from '@galop/component-library';
import Can from '../Shared/Can';
import { AppAbbreviation, AppName } from '../../App';

export const NavMenu = (props) => {
    //const { CurrentUser } = props;
    const [collapsed, setCollapsed] = useState(true);
    const activePath = window.location.pathname;

    const toggleNavbar = () => {
        setCollapsed(!collapsed);
    };

    const navContents = (
        <Container fluid>
            <NavbarBrand tag={Link} to="/" className="d-none d-md-block">{AppName}</NavbarBrand>
            <NavbarBrand tag={Link} to="/" className="d-block d-md-none">{AppAbbreviation}</NavbarBrand>
            <NavbarToggler onClick={toggleNavbar} className="ml-auto mr-2 border-0" />
            <Collapse isOpen={!collapsed} navbar>
                <ul className="navbar-nav flex-fill justify-content-around justify-content-lg-start">
                    <Can role=""
                        yes={() => {
                            const path = "/";
                            return (<NavItem>
                                <NavLink tag={Link} className="" to={path} onClick={() => setCollapsed(true)} active={activePath === path}><FontAwesomeIcon icon={faHome} /><span className=" ml-2" /* className="d-none d-lg-inline ml-2"*/>Home</span></NavLink>
                            </NavItem>);
                        }
                        } />
                    <Can role="admin"
                        yes={() => {
                            const path = "/assets";
                            return (<NavItem>
                                <NavLink tag={Link} className="" to={path} onClick={() => setCollapsed(true)} active={activePath.includes(path)}><FontAwesomeIcon icon={faList} /><span className=" ml-2">Assets</span></NavLink>
                            </NavItem>);
                        }
                        } />
                    <Can role=""
                        yes={() => {
                            const path = "/reports";
                            return (<NavItem>
                                <NavLink tag={Link} className="" to={path} onClick={() => setCollapsed(true)} active={activePath.includes(path)}><FontAwesomeIcon icon={faNewspaper} /><span className=" ml-2">Reports</span></NavLink>
                            </NavItem>);
                        }
                        } />
                    <Can role="admin"
                        yes={() => {
                            const path = "/users";
                            return (<NavItem>
                                <NavLink tag={Link} className="" to={path} onClick={() => setCollapsed(true)} active={activePath.includes(path)}><FontAwesomeIcon icon={faUserFriends} /><span className=" ml-2">Users</span></NavLink>
                            </NavItem>);
                        }
                        } />
                </ul>
            </Collapse>
            <Can role=""
                yes={() => <UserPearl CurrentUser={props.CurrentUser} />} />
        </Container>
    );

    return (
        <header className="d-block" /*className="sticky-top"*/>
            <Navbar className="d-none d-lg-block navbar-expand-md navbar-toggleable-md bg-off-white" light>
                {navContents}
            </Navbar>
            <Navbar className="d-block d-lg-none navbar-expand fixed-bottom bg-off-white" light>
                {navContents}
            </Navbar>
        </header>
    );
};


// WEBPACK FOOTER //
// ./src/components/Shared/NavMenu.js